// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"26006532","148":"d97b0c9c","220":"6afe53ee","224":"5aa67435","252":"40892d9f","420":"ec1d585c","540":"7ba95328","592":"6e294d14","632":"3701a8fc","644":"593c4ad4","660":"762ab88b","768":"3d6db400","808":"bd866e4b","884":"98fec886","897":"c9b21650"}[chunkId] + ".chunk.js";
};